export default {
  logo: "乐辰生物",
  common: {
    welcome: "欢迎",
    about: "关于我们",
    contact: "联系我们",
    newCenter: "新闻中心",
    instrument: "仪器",
    home: '主页',
    product: '产品',
    solution: '解决方案',
    newsCenter: '新闻中心',
    aboutUs: '关于我们',
    joinUs: '加入我们',
    contactUs: '联系我们',
    recruitment: '人才招聘'
  },
  productList: {
    instrument: "仪器",
    reagent: '试剂',
    software: '软件'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh-CN.js